import React, { useContext } from 'react'
import StickyBar from '../shared/StickyBar'
import debounce from 'debounce'
import Filter from '../shared/Filter'
import { store } from '../../stores/admin_templates'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'

export default function TemplateFilter() {
  const { status, query, human_name, basepath, dispatch, actions } = useContext(store)
  const setQuery = (query) => {
    dispatch({ type: actions.SET_QUERY, payload: query })
  }

  const setStatus = (status) => {
    dispatch({ type: actions.SET_STATUS, payload: status })
  }

  const debouncedSetQuery = debounce(setQuery, 300)

  return (
    <StickyBar className="mb-4">
      <Filter title={`Filter ${human_name}s…`} query={query} onChange={debouncedSetQuery} className="col-12 col-md ps-3" />
      <div className="col-auto ps-3">
        <UncontrolledDropdown>
          <DropdownToggle caret color="link" className="text-dark text-capitalize">
            {status} {human_name}s
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem className={`${status == 'all' ? 'bg-gray' : ''}`} onClick={() => setStatus('all')}>All {human_name}s</DropdownItem>
            <DropdownItem className={`${status == 'active' ? 'bg-gray' : ''}`} onClick={() => setStatus('active')}>Active {human_name}s</DropdownItem>
            <DropdownItem className={`${status == 'inactive' ? 'bg-gray' : ''}`} onClick={() => setStatus('inactive')}>Inactive {human_name}s</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
      <div className="col-auto ps-3">
        <a href={`${basepath}/new`} className="btn btn-primary btn-sm">Add a {human_name}</a>
      </div>
    </StickyBar>
  )
}
